import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";
import { BANK_ACCOUNT_REGEX, ERROR_MESSAGES } from "constants/validation";

/**
 * Banking Info Schema
 * Base schema is loose to allow loading legacy data.
 */
export const BankingInfoSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    accountNumber: Yup.string()
      .nullable()
      .transform((val) => (val ? val.replace(/\D/g, "") : val)), // Loose for loading
    accountName: Yup.string().nullable(),
    bankName: Yup.string().nullable(),
    branchName: Yup.string().nullable(),
  });

/**
 * Banking Info Validation Schema
 * Strict rules applied only during form submission.
 */
export const BankingInfoValidationSchema = BankingInfoSchema.clone().shape({
  accountNumber: Yup.string()
    .required(ERROR_MESSAGES.REQUIRED)
    .nullable()
    .transform((val) => (val ? val.replace(/\D/g, "") : val))
    .matches(BANK_ACCOUNT_REGEX, ERROR_MESSAGES.BANK_ACCOUNT_FORMAT),
  accountName: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  bankName: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  branchName: Yup.string().required(ERROR_MESSAGES.REQUIRED),
});
